var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgContrabass = function SvgContrabass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    vectorEffect: "non-scaling-stroke",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    vectorEffect: "non-scaling-stroke",
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.947 16.257a3.09 3.09 0 0 1 2.888-.854c.117-.1.243-.181.353-.292a5.39 5.39 0 0 0 .147-7.573 5.285 5.285 0 0 0-7.512.148c-.11.111-.191.238-.29.356a3.15 3.15 0 0 1-.847 2.911 3.02 3.02 0 0 1-4.234.133 7 7 0 0 0-.606.5 6.93 6.93 0 0 0-.189 9.737 6.8 6.8 0 0 0 9.659-.191 7 7 0 0 0 .5-.611 3.077 3.077 0 0 1 .131-4.264M4.5 19.501.75 23.249M23.25.751l-12 12m9-12 3 3M18 3.001l3 3M6.866 14.963l-1.579.53m3.683 1.591-.526 1.591"
  })));
};
export default SvgContrabass;